import { combineReducers } from 'redux'
import { CurrentUser, EMPTY_USER } from '../../../responses/users'
import { createReducer } from 'typesafe-actions'
import { payloadReducer } from '../../../utils/redux-utils'
import { userActions } from './user-actions'
import { PERMISSIONS } from '../../../constants/permissions'

export interface UserState {
    token: string,
    data: CurrentUser,
}

const EMPTY_CURRENT_USER: CurrentUser = {
    ...EMPTY_USER,
    new_projects: 0,
    notifications_count: 0,
    targeted_tasks: 0,
    paused_projects: 0,
    requested_tasks: 0,
    roles: [],
    permissions: [PERMISSIONS.SETTINGS.ACCESS],
    direction_id: 0,
    settings: {},
    notification_settings: {},
    notification_method_settings: {}
}

export const userReducer = combineReducers<UserState>({
    token: createReducer('')
        .handleAction([userActions.login.success, userActions.refreshToken.success], payloadReducer)
        .handleAction(userActions.logout.success, () => ''),
    data: createReducer<CurrentUser>(EMPTY_CURRENT_USER)
        .handleAction(userActions.logout.success, () => EMPTY_CURRENT_USER)
        .handleAction([userActions.update.success, userActions.info.success], payloadReducer),
})